var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.5,
    height: 45.5,
    viewBox: "0 0 38.5 45.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15660",
    "data-name": "Path 15660",
    d: "M31.75,39.5A12.25,12.25,0,1,1,33.5,15.14V9.75A1.75,1.75,0,0,0,31.75,8H30V2.75A1.75,1.75,0,0,0,28.25,1h-21A5.25,5.25,0,0,0,2,6.25v35A5.25,5.25,0,0,0,7.25,46.5h24.5a1.75,1.75,0,0,0,1.75-1.75V39.36a12.3,12.3,0,0,1-1.75.14ZM5.5,6.25A1.75,1.75,0,0,1,7.25,4.5H26.5V8H7.25A1.75,1.75,0,0,1,5.5,6.25Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15661",
    "data-name": "Path 15661",
    d: "M22.75,11a8.75,8.75,0,1,0,8.75,8.75A8.75,8.75,0,0,0,22.75,11Zm4.737,7.655L22.82,23.32a1.75,1.75,0,0,1-2.474,0l-2.333-2.333a1.75,1.75,0,1,1,2.475-2.475l1.1,1.1,3.43-3.428a1.75,1.75,0,1,1,2.475,2.475Z",
    transform: "translate(9 7.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIcon);
export default __webpack_public_path__ + "static/media/ccIcon.04f3fe39d0623b194b86c3c650626228.svg";
export { ForwardRef as ReactComponent };